<template>
    <div class="container">
        <div class="incontainer">
            <div class="movie">
            <div class="movcontainer">
                <div class="movies">
                    <div class="movies-name">
                        <ul>
                            <li :class="{ active : selectedSongs.url == sound.url}"  v-for="(sound, index) in videoData" :key="index" @click="openSound(index)">
                               <a> {{ sound.title }}</a>
                            </li>
                        </ul>
                    </div>
                    <div class="movies-player" >
                        <div class="movies-player-video" v-if="selectedSongs">
                            <div class="movies-player-video-title">
                                <h4 >{{ selectedSongs.title }}</h4>
                            </div>
                            
                            <iframe  allowfullscreen  frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" class="iframe" :src="'https://www.youtube.com/embed/'+this.selectedSongs.url" controls></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
    </div>
      </template>
      
      <script>
    
      export default {
        name:'albumYarasi',
        data() {
          return {
            videoData: [
              {
                title: 'Gözlerini Güneşim Seçtim',
                url: 'h0JNUuFwO1s'
              },
              {
                title: 'Sevda Dalgaları',
                url: 'cvgg6x2XSf8'
              },
              {
                title: 'Bu Gece Uzun Olacak',
                url: 'FnIzXjKK0qA'
              },
              {
                title: 'Sensiz Kaldım',
                url: 'TMSjLlCmYTY'
              },
              {
                title: 'Adamım',
                url: '6F0NuhBy7gA'
              },
              {
                title: 'Yarası Saklım',
                url: 'bGGIVeWDkBY'
              },
              {
                title: 'Yürü Ya Kulum',
                url: 'kY-DBRMqE3U'
              },
              {
                title: 'Ben Aşkı Böyle Tanımamıştım',
                url: 'DyV2muYDRT0'
              },
              {
                title: 'Niye Yoksun',
                url: 'cSiuxoFqQgo'
              },
              {
                title: 'Vallahi Billahi',
                url: 'cMemXSG1sKg'
              },
              
              // diğer videolar
            ],
            selectedSongs: {
                title: 'Gözlerini Güneşim Seçtim',
                url: 'h0JNUuFwO1s'
          }
            
          };
        },
        methods:{
            openSound(index) {
                this.selectedSongs = this.videoData[index];
                console.log(this.selectedSongs.url)
            }
        }
      };
    
    
      </script>
      
      <style scoped>
    
    
      </style>
    
